import { Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { createGetDepartmentWorkerOptions } from '../../queries/departmentQueries';
import { createGetSiteOwnerOptions } from '../../queries/siteOwnerQueries';
import { SiteReviewTitle } from '../../styles';
import Popup from '../atoms/popup';
import Button from './Button';
import SingleValuePopup from './SingleValuePopup';

function ReassignResource(props) {
  const [openChangeResource, setOpenChangeResource] = useState(false);
  const { data, isLoading, error } = useQuery(
    createGetDepartmentWorkerOptions(
      {
        departmentId: props.departmentId,
        siteId: props.siteId,
      },
      {
        enabled: props.open,
      }
    )
  );
  const {
    data: siteOwner,
    isLoading: isSiteOwnerLoading,
    error: siteOwnerError,
  } = useQuery(
    createGetSiteOwnerOptions(
      {
        pecrId: props.pecrId,
        siteId: props.siteId,
      },
      {
        enabled: props.open,
      }
    )
  );
  return (
    <>
      <Grid style={SiteReviewTitle}>
        <Button
          message="Reassign Resource"
          onClick={() => setOpenChangeResource(!openChangeResource)}
          type="primary"
        />
      </Grid>
      {openChangeResource && !props.disabled && data && siteOwner && (
        <Popup
          title={props.title}
          department={props.departmentName}
          open={openChangeResource}
          handleClose={() => setOpenChangeResource(false)}
        >
          <SingleValuePopup
            // defaultPopupData={[]}
            updatedBy={props.updatedBy}
            siteCoordinator={props.siteCoordinator}
            departmentName={props.departmentName}
            popupData={data}
            handleClose={() => setOpenChangeResource(false)}
            pecrId={props.pecrId}
            siteId={props.siteId}
            departmentId={props.departmentId}
            siteOwner={siteOwner.SOwnerID}
            subDepartment={props.subDepartment}
          />
        </Popup>
      )}
    </>
  );
}

ReassignResource.propTypes = {
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  departmentName: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  pecrId: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  departmentId: PropTypes.string.isRequired,
  updatedBy: PropTypes.number.isRequired,
  siteCoordinator: PropTypes.number.isRequired,
  subDepartment: PropTypes.string.isRequired,
};

export default ReassignResource;
